import React from 'react';
import { FormattedMessage } from 'react-intl';

export default () => (
  <FormattedMessage id="subscribe-modal.step2.header" defaultMessage="Subscribe to IDAGIO" />
);
